import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterEdicaoPorDataState } from '../../reducers/Jornal/obter-edicao-por-data-publicacao.reducer';

export const selectObterEdicaoPorDataState = createFeatureSelector<ObterEdicaoPorDataState>('obterEdicaoPorData');

export const selectDadosObterEdicaoPorData = createSelector(
    selectObterEdicaoPorDataState,
    (state: ObterEdicaoPorDataState) => state.response
);

export const selectObterEdicaoPorData = createSelector(
  selectObterEdicaoPorDataState,
  (state: ObterEdicaoPorDataState) => state
);

export const selectErrosObterEdicaoPorData = createSelector(
    selectObterEdicaoPorDataState,
    (state: ObterEdicaoPorDataState) => state.error
);
